// extracted by mini-css-extract-plugin
export const list = "CruiseItineraryPortsSummary-module--list--2-Y7j";
export const item = "CruiseItineraryPortsSummary-module--item--1MD3d";